import JogoDaSomaImage from '../../assets/images/jogoDaSoma.png'
import RisesoftImage from '../../assets/images/risesoftGP.png'
import SistemaGestaoImage from '../../assets/images/sistemaGestao.png'
import FabiAzevedoImage from '../../assets/images/siteFabiAzevedo.png'
import WeatherAppImage from '../../assets/images/weatherApp.png'
import NumeroSecretoImage from '../../assets/images/numeroSecreto.png'

const data = [
    {
        id: 1,
        img: JogoDaSomaImage,
        title: 'Jogo da Soma - App',
        desc: 'Jogo desenvolvido para a alfabetização das crianças com a matemática.',
        tecnology: 'React Native / Expo',
        link: 'https://github.com/mateusgabrielsilva/jogoDaSomaApp'
    },
    {
        id: 2,
        img: SistemaGestaoImage,
        title: 'Web Gestão de Projetos - Sistema Web',
        desc: 'Sistema web completo de gestão de projetos com Kanban.',
        tecnology: 'HTML / CSS / JavaScript / PHP ',
        link: 'https://risesoft.com.br'
    },
    {
        id: 3,
        img: RisesoftImage,
        title: 'Risesoft - Website',
        desc: 'Website institucional sobre o produto Risesoft Gestão de Projetos.',
        tecnology: 'HTML / CSS',
        link: 'https://risesoft.com.br'
    },
    {
        id: 4,
        img: FabiAzevedoImage,
        title: 'Fabi Azevedo Arq - Website',
        desc: 'Website institucional criado para uma aquiteta da região.',
        tecnology: 'HTML / CSS / JavaScript',
        link: 'https://studiofabiazevedo.arq.br/'
    },
    {
        id: 5,
        img: WeatherAppImage,
        title: 'Weather App - App',
        desc: 'Aplicativo desenvolvido para consumo de API de clima atual com localização do usuário.',
        tecnology: 'React Native / Expo',
        link: 'https://github.com/mateusgabrielsilva/Weather-App'
    },
    {
        id: 6,
        img: NumeroSecretoImage,
        title: 'Número Secreto - Website',
        desc: 'Nesse jogo via browser você vai falando o número até acertar o correto. Boa Sorte!',
        tecnology: 'HTML / CSS / JavaScript',
        link: 'https://mateusjogosecreto.netlify.app/'
    },
]

export default data